import PdfTemplate from './PdfTemplate';

export { type PdfTemplateProps } from './PdfTemplate';
export default PdfTemplate;
